// extracted by mini-css-extract-plugin
module.exports = {"sidebarItem":"SidebarItem_sidebarItem__ZS7PO","label":"SidebarItem_label__4ewdd","isActive":"SidebarItem_isActive__2MoX7"};